interface PolicyLink {
  title: string;
  link: string;
}

interface PolicyData {
  policy: PolicyLink[];
}

export const data: PolicyData = {
  policy: [
    {
      title: "Terms of Use",
      link: "/our/brand/support/legal/terms-of-use/",
    },
    {
      title: "Privacy Policy",
      link: "/our/brand/support/privacy-policy/",
    },
    {
      title: "Consumer Health Data Privacy Policy",
      link: "/consumer-health-data-privacy-policy/",
    },
    {
      title: "AdChoices - Do Not Sell or Share",
      link: "adchoices",
    },
    {
      title: "Do Not Sell or Share My Personal Information",
      link: "/our/brand/support/legal/privacy-request/",
    },
    {
      title: "Limit Use of My Sensitive Personal Information",
      link: "/our/brand/support/legal/privacy-request/?preselected=limit",
    },
    {
      title: "Sitemap",
      link: "/sitemap/",
    },
  ],
};
